import { Box, Flex, Switch, Text } from "@chakra-ui/react";

interface ToggleRowProps {
  label: string;
  description: string;
  checked: boolean;
  onChange: (val: boolean) => void;
  isLast?: boolean;
}

export function ToggleRow({
  label,
  description,
  checked,
  onChange,
  isLast = false,
}: ToggleRowProps) {
  return (
    <Flex
      justify="space-between"
      align="flex-start"
      py={3.5}
      _first={{ pt: 0 }}
      borderBottom={isLast ? "none" : "1px solid"}
      borderColor="transparent.white.05"
      gap={4}
    >
      <Box flex={1}>
        <Text fontSize="md" color="dune.dune">
          {label}
        </Text>
        <Text fontSize="xs" color="transparent.white.40" mt={0.5}>
          {description}
        </Text>
      </Box>
      <Switch
        isChecked={checked}
        onChange={(e) => onChange(e.target.checked)}
        variant="brandSwitch"
        mt={0.5}
      />
    </Flex>
  );
}
